import { transitionPath } from 'router5';
import { getRoute } from './get-route';
export var getActivatedRoutes = function (toState, fromState, routes) {
    var toActivate = transitionPath(toState, fromState).toActivate;
    if (!toActivate.includes(toState.name)) {
        toActivate.push(toState.name);
    }
    return toActivate.map(function (segment) { return getRoute(segment, routes); });
};
